import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  backendUrl: 'https://dev.citydeals.hu/api',
  backendStorageBaseUrl: 'https://dev.citydeals.hu',
  extraPlugins: [],
  frontpageSiteUrl: 'https://dev.citydeals.hu',
  tenapodPartnerUrl: 'https://partner.dev.tenapod.shop',
};
